<template>
  <div class="content" style="min-height: 100vh; overflow: auto">
    <div class="mask-cont m-t-10">
      <div class="content-winner">
        <div class="d-flex">
<!-- 赢家奖杯:内联 SVG 取代绿色 PNG(铁律②金=奖;CSS var 经 style 注入,fill 属性不支持 var) -->
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            style="margin-top: -2px; fill: var(--vk-gold)"
            aria-hidden="true"
          >
            <path
              d="M6 4V3.5A1.5 1.5 0 0 1 7.5 2h9A1.5 1.5 0 0 1 18 3.5V4h2.5A1.5 1.5 0 0 1 22 5.5V7a4 4 0 0 1-4 4h-.5a6 6 0 0 1-4.5 3.92V17h3a1 1 0 0 1 1 1v2H7v-2a1 1 0 0 1 1-1h3v-2.08A6 6 0 0 1 6.5 11H6a4 4 0 0 1-4-4V5.5A1.5 1.5 0 0 1 3.5 4H6Zm0 2H4v1a2 2 0 0 0 2 2V6Zm12 3a2 2 0 0 0 2-2V6h-2v3Z"
            />
            <path
              style="fill: var(--vk-bg)"
              d="m12 5 1.12 2.27 2.5.36-1.81 1.77.43 2.49L12 10.72 9.76 11.9l.43-2.49L8.38 7.63l2.5-.36Z"
            />
          </svg>
          <p class="f-t-15 m-l-5 f-w">{{ $lang.home_txt2 }}</p>
        </div>
        <div v-if="homeWinningReadError" class="home-read-error">
          {{ homeWinningReadError }}
        </div>
        <div v-if="homeWinnerEmptyState" class="home-empty home-winner-empty">
          {{ $lang.winner_empty || 'No winners yet' }}
        </div>
        <!-- 自定义从左到右轮播：支持左右滑动、无限循环 -->
        <div
          v-else
          class="winner-carousel-wrap"
          ref="winnerCarouselWrap"
          @touchstart="onWinnerTouchStart"
          @touchmove="onWinnerTouchMove"
          @touchend="onWinnerTouchEnd"
        >
          <div
            class="winner-carousel-track"
            :class="{ 'winner-carousel-no-transition': winnerNoTransition }"
            :style="winnerTrackStyle"
            ref="winnerCarouselTrack"
          >
            <div
              v-for="(item, index) in winnerDisplayList"
              :key="'winner-' + index"
              class="item-sider winner-carousel-item"
            >
              <div style="position: relative">
                <van-image
                  class="swiper-slide--img"
                  :src="item.gameIcon"
                  lazy-load
                  style="height: 82px"
                >
                  <template v-slot:loading>
                    <van-loading size="20" color="#ff5a1f" vertical />
                  </template>
                </van-image>

                <p
                  class="d-flex"
                  style="
                    position: absolute;
                    right: 0;
                    left: 0;
                    bottom: 2px;
                    margin: 0 auto;
                    font-size: var(--vk-fs-2xs);
                    backdrop-filter: blur(10px) grayscale(30%);
                    height: 35px;
                    justify-content: center;
                    padding-bottom: 5px;
                    padding-top: 5px;
                    border-radius: 0 0 8px 8px;
                    color: #ffffff;
                    text-align: center;
                  "
                >
                  {{ item.gameName }}
                </p>
              </div>

              <div class="item-sider--t">
                <div class="d-flex" style="margin: 8px 0 0">
                  <img
                    src="../../assets/img/common/logo_winner.png"
                    width="10"
                  />
                  <p class="m-l-5">{{ item.userName }}</p>
                </div>
                <p class="primary-color content-winner--t">
                  {{ $formatNumberWithCommas(item.amount) || 0 }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-serach" @click="$jumpTo('/searchGame')">
        <div class="search-entry-wrap">
          <img
            src="../../assets/img/common/ssk_com.png"
            width="18"
            class="search-entry-icon"
          />
          <span class="search-entry-placeholder">{{
            $lang.menu_search_placeholder
          }}</span>
        </div>
      </div>
      <div
        v-if="pgDate.dataList && pgDate.dataList.length > 0"
        class="content-tab"
        ref="targetElement"
      >
        <div v-if="homeGameReadError" class="home-read-error">
          {{ homeGameReadError }}
        </div>
        <div class="content-tab--s">
          <van-loading v-if="loading" color="#ff5a1f" vertical> </van-loading>
        </div>
        <van-tabs
          @click="tabSelect"
          v-model="activeTab"
          title-inactive-color="#ffffff"
          title-active-color="#ffffff"
          :ellipsis="false"
          lazy-render
        >
          <van-tab
            v-for="(item, index) in pgDate.dataList"
            :key="index + 'xx'"
          >
            <template #title>
              <div
                class="tab-title-column d-flex"
                :class="{ 'a-ccc': activeTab === index }"
              >
                <img :src="item.icon" class="tab-icon" />
                <span class="tab-text f-t-12 m-l-5">{{ item.name }}</span>
              </div>
            </template>

            <div
              class="content-tab--c"
              style="margin-left: 12px; margin-right: 12px"
            >
              <!-- sortType === 1: 厂商分类，只展示厂商icon列表 -->
              <div v-if="item.sortType === 1" class="vendor-grid">
                <div
                  v-for="(item2, index2) in safeTypes(item)"
                  :key="index2"
                  class="vendor-grid__item"
                  @click="goVendor(item2)"
                >
                  <img :src="item2.icon" class="vendor-grid__icon" />
                </div>
              </div>
              <!-- sortType === 0 或 3: 普通游戏分类，正常展示 -->
              <div
                v-else
                v-for="(item2, index2) in safeTypes(item)"
                :key="index2"
              >
                <keep-alive>
                  <resher-siper2
                    v-if="!allOpen && gameList(item2).length > 0"
                    :siderData="item2"
                    :siderIndex="index"
                    @getBack="getBacks"
                    ref="swipe2"
                  ></resher-siper2>
                </keep-alive>
              </div>
            </div>
          </van-tab>

          <div class="content-bbttom" style="padding: 20px 0 50px">
            <div style="width: 90%; margin: 0 auto">
              <p class="t-c">{{ $lang.common_txt358 }}</p>

              <div class="t-c m-t-20">
                <img
                  v-for="(item, index) in socialLinks"
                  :key="index"
                  :src="item.src"
                  width="34"
                  class="m-l-10 m-r-10"
                  style="cursor: pointer;"
                  @click="openConfiguredSocialLink(item.serviceType)"
                />
              </div>

              <p class="content-line m-t-10"></p>

              <p class="t-c">{{ $lang.common_txt359 }}</p>

              <div class="t-c m-t-20">
                <img
                  v-for="(item, index) in communityLinks"
                  :key="index"
                  :src="item.src"
                  width="34"
                  class="m-l-10 m-r-10"
                  style="cursor: pointer;"
                  @click="openConfiguredSocialLink(item.serviceType)"
                />
              </div>
              <p class="content-line m-t-10"></p>
              <p class="t-c">{{ $lang.common_txt360 }}</p>
              <div class="t-c m-t-20">
                <img src="../../assets/img/otgame/cooper.png" width="100%" />
              </div>

              <p class="content-line m-t-10"></p>
              <div class="t-c">
                <img src="../../assets/img/otgame/eighteen.png" width="34" />
                <p
                  style="color: var(--vk-t2); font-size: var(--vk-fs-xs)"
                  v-html="$lang.common_txt361"
                ></p>
              </div>
            </div>
          </div>
        </van-tabs>
      </div>
      <van-empty
        v-else-if="homeGameLoaded"
        class="home-empty"
        :image="require('../../assets/img/common/img_no_data.png')"
        :description="homeGameError ? ($lang.network_error || 'Network error') : ($lang.noempt || 'No games available')"
      />
    </div>

    <login v-model="showPopup" overlay></login>
    <!-- 大转盘 -->
    <lucky-roulette v-model="isShowPopup" overlay></lucky-roulette>

    <van-popup
      v-model="showDialog"
      class="custom-popup2"
      :closeable="false"
      :close-on-click-overlay="false"
    >
      <div class="cont-redim"></div>
      <div class="d-flex-s m-t-10">
        <div class="d-flex">
          <van-checkbox
            v-model="agree"
            shape="square"
            icon-size="16px"
            icon-color="#202A39"
            style="
              border: 1px solid #6f7887;
              margin-right: 3px;
              border-radius: 5px;
            "
          ></van-checkbox>
          <p style="color: #ffffff; font-size: var(--vk-fs-xs)">{{ $lang.home_txt7 }}</p>
        </div>
        <div class="d-flex">
          <van-checkbox
            v-model="agree2"
            shape="square"
            icon-size="16px"
            icon-color="#202A39"
            style="
              border: 1px solid #6f7887;
              margin-right: 3px;
              border-radius: 5px;
            "
          ></van-checkbox>
          <p style="color: #ffffff; font-size: var(--vk-fs-xs)">{{ $lang.home_txt8 }}</p>
        </div>
      </div>

      <img
        class="m-t-10"
        @click="closeF()"
        src="../../assets/img/lucky_jackpot/img_cancel.png"
        width="38"
      />
    </van-popup>
    <!-- 活动 -->
    <activity-popup
      v-model="isShowPopup2"
      @closeActive="closeActive"
      @closeActive2="closeActive2"
    ></activity-popup>
  </div>
</template>
<script>
import scrollIntoView from 'scroll-into-view-if-needed'
import {
  GetCsLink,
  GetHomeWinningGameList,
  GetHomeGameList,
  GetIsFbReport,
  ActivitygetRegisterAward,
  GetPlatformList,
  GetInvitationID
} from '@/api/common'
import { logoutIfReloginRequiredWithToken } from '@/utils/platformAuth'
import { safeGetStorageItem, safeLocalStorage, safeRemoveStorageItem, safeSessionStorage, safeSetStorageItem } from '@/utils/safeStorage'
import {
  getVisibleGameGroups,
  isLaunchUnavailableToken,
  isUnavailableLaunchEntry,
  normalizeHomeGameContent,
  toArray
} from '@/components/home/gameLaunch'
import {
  filterDisplayGameGroups,
  gameResponseBody,
  isHomeGameReadableResponse
} from '@/views/details/home/gameResponse'
import {
  isNeedLogin,
  isOkResponse,
  isReadableOkResponse,
  hasUnavailableMarker,
  openExternalUrl,
  responseContent,
  responseFailMessage,
  safeObject,
  safeString
} from './safeLayout'
import { resolveCustomerServiceLink } from './csLink'
import { SINGLE_COUNTRY } from '@/config/singleCountry'
// import ResherSiper from '../../components/home/ResherSiper.vue'
import ResherSiper2 from '../../components/home/ResherSiper2.vue'
// import ResherContent from '../../components/home/ResherContent.vue'
// import MenuHome from '../../components/home/MenuHome.vue'

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

function getSessionStorage() {
  try {
    if (typeof safeSessionStorage === 'function') return safeSessionStorage()
  } catch (e) { return null }
  return null
}

function browserWindow() {
  return typeof window !== 'undefined' && window ? window : null
}

function getKwaiq() {
  const win = browserWindow()
  return win && win.kwaiq ? win.kwaiq : null
}

const HOME_CATEGORY_LIST_KEYS = [
  'dataList',
  'list',
  'gameList',
  'game_list',
  'allGameList',
  'records',
  'items',
  'categoryList',
  'categories',
  'games'
]
const HOME_CATEGORY_NESTED_LIST_KEYS = [
  'category',
  'categories',
  'game',
  'games',
  'page',
  'pageInfo',
  'result',
  'payload',
  'data',
  'body',
  'content',
  'extra'
]

// 用户向中性文案(脱敏;per-locale i18n 见 P1)
const HOME_SOCIAL_UNAVAILABLE_MESSAGE = 'This link is temporarily unavailable. Please try again later.'
const HOME_VENDOR_ENTRY_UNAVAILABLE_MESSAGE = 'This provider is temporarily unavailable. Please try again later.'
const HOME_SOCIAL_LINK_ALIASES = {
  facebook: ['facebook', 'facebookUrl', 'fb', 'fbUrl'],
  twitter: ['twitter', 'twitterUrl', 'x', 'xUrl'],
  instagram: ['instagram', 'instagramUrl', 'ins', 'insUrl'],
  tiktok: ['tiktok', 'tiktokUrl', 'tk', 'tkUrl'],
  telegram: ['telegram', 'telegramUrl', 'tg', 'tgUrl']
}
const HOME_SOCIAL_LIST_KEYS = ['socialLinks', 'socialLinkList', 'linkList', 'list', 'url2', 'csLinkList']

function resolveHomeSocialLink(response, serviceType) {
  const type = normalizeHomeSocialType(serviceType)
  if (!type || !response || !isReadableOkResponse(response) || hasUnavailableMarker(response)) {
    return blockedHomeSocialLink(response)
  }

  if (type === 'telegram') {
    const customerServiceLink = resolveCustomerServiceLink(response, type)
    if (customerServiceLink.ok) {
      return customerServiceLink
    }
  }

  const content = responseContent(response)
  if (hasUnavailableMarker(content)) {
    return blockedHomeSocialLink(response)
  }

  const directUrl = resolveHomeSocialDirectUrl(content, type)
  if (directUrl) {
    return {
      ok: true,
      url: directUrl,
      message: ''
    }
  }

  const listUrl = resolveHomeSocialListUrl(content, type)
  if (listUrl) {
    return {
      ok: true,
      url: listUrl,
      message: ''
    }
  }

  return blockedHomeSocialLink(response)
}

function blockedHomeSocialLink(response) {
  return {
    ok: false,
    url: '',
    message: responseFailMessage(response, HOME_SOCIAL_UNAVAILABLE_MESSAGE)
  }
}

function normalizeHomeSocialType(serviceType) {
  return safeString(serviceType).trim().toLowerCase()
}

function resolveHomeSocialDirectUrl(content, type) {
  const source = safeObject(content)
  for (const key of HOME_SOCIAL_LINK_ALIASES[type] || [type]) {
    const url = safeHomeHttpUrl(source[key])
    if (url) return url
  }
  return ''
}

function resolveHomeSocialListUrl(content, type) {
  const source = safeObject(content)
  for (const key of HOME_SOCIAL_LIST_KEYS) {
    const list = toArray(source[key])
    for (const item of list) {
      const row = safeObject(item)
      if (hasUnavailableMarker(row)) continue
      if (!homeSocialRowMatchesType(row, type)) continue
      const url = resolveHomeSocialDirectUrl(row, type) || safeHomeHttpUrl(row.url || row.href || row.link || row.linkUrl || row.link_url || row.value)
      if (url) return url
    }
  }
  return ''
}

function homeSocialRowMatchesType(row, type) {
  const targetAliases = HOME_SOCIAL_LINK_ALIASES[type] || [type]
  const haystack = [
    row.type,
    row.linkType,
    row.link_type,
    row.channel,
    row.name,
    row.title,
    row.platform
  ].map(value => safeString(value).toLowerCase()).join(' ')
  if (!haystack) return false
  return targetAliases.some(alias => haystack.includes(alias.toLowerCase()))
}

function safeHomeHttpUrl(value) {
  const url = safeString(value).trim()
  try {
    const parsed = new URL(url)
    if (!['http:', 'https:'].includes(parsed.protocol)) return ''
    if (!parsed.hostname) return ''
    return url
  } catch (e) {
    return ''
  }
}
const HOME_CATEGORY_ID_KEYS = [
  'gid',
  'gameId',
  'game_id',
  'favoriteId',
  'favorite_id',
  'launchId',
  'launch_id'
]
const HOME_CATEGORY_PROOF_KEYS = [
  'writeProof',
  'write_proof',
  'launchProof',
  'launch_proof',
  'favoriteProof',
  'favorite_proof',
  'proof',
  'proofId',
  'proof_id'
]
const HOME_CATEGORY_FLAG_KEYS = [
  'readOnlyMode',
  'read_only_mode',
  'mockMode',
  'mock_mode',
  'falseProof',
  'false_proof',
  'failClosed',
  'fail_closed',
  'placeholder',
  'readUnavailable',
  'read_unavailable',
  'routeUnavailable',
  'route_unavailable',
  'technicalMarker',
  'technical_marker',
  'technicalError',
  'technical_error',
  'technicalException',
  'technical_exception',
  'backendFailure',
  'backend_failure',
  'backendBlocked',
  'backend_blocked',
  'notConnected',
  'not_connected'
]
const HOME_CATEGORY_URL_KEYS = [
  'forwardUrl',
  'forward_url',
  'url',
  'gameUrl',
  'game_url',
  'launchUrl',
  'launch_url',
  'playUrl',
  'play_url',
  'redirectUrl',
  'redirect_url',
  'iframeUrl',
  'iframe_url'
]
const SHARE_FAILED_MESSAGE = '分享未完成，请稍后重试或复制链接分享。'
const SHARE_UNSUPPORTED_MESSAGE = '当前浏览器不支持系统分享，请复制链接后分享。'
const SHARE_CANCELLED_NAMES = ['aborterror', 'notallowederror']
const GENERIC_SHARE_FAILURE_RE = /^(request failed|network error|sharing failed|share failed|\[object object\])$/i

function shareFailureMessage(error) {
  const errorName = safeString(error && error.name).toLowerCase()
  if (SHARE_CANCELLED_NAMES.includes(errorName)) {
    return ''
  }
  const message = safeString(error && error.message)
  return message && !GENERIC_SHARE_FAILURE_RE.test(message) ? message : SHARE_FAILED_MESSAGE
}

function canUseNativeShare() {
  try {
    return typeof navigator !== 'undefined' && navigator && typeof navigator.share === 'function'
  } catch (e) {
    return false
  }
}

function getNativeShare() {
  try {
    const nav = typeof navigator === 'undefined' ? null : navigator
    return nav && typeof nav.share === 'function' ? { nav, share: nav.share } : null
  } catch (e) {
    return null
  }
}

function safeScrollIntoView(resolveTarget, options) {
  try {
    const target = typeof resolveTarget === 'function' ? resolveTarget() : resolveTarget
    if (!target) return false
    scrollIntoView(target, options)
    return true
  } catch (e) {
    return false
  }
}

function safeToast(vm, payload) {
  if (vm && typeof vm.$toast === 'function') vm.$toast(payload)
}

function homeCategoryObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {}
}

function homeCategoryToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function hasHomeCategoryKey(source, key) {
  return Object.prototype.hasOwnProperty.call(source, key)
}

function isHomeCategoryFalseProof(value) {
  if (value === false || value === 0) return true
  return ['false', '0', 'no', 'off'].includes(homeCategoryToken(value))
}

function isHomeCategoryActiveBlock(value) {
  const token = homeCategoryToken(value)
  if (value === true || value === 1) return true
  return ['true', '1', 'yes', 'on'].includes(token) ||
    token.includes('placeholder') ||
    token.includes('fail_closed') ||
    token.includes('fail-closed') ||
    token.includes('fail closed') ||
    token.includes('failclosed') ||
    token.includes('technicalmarker') ||
    token.includes('technical_marker') ||
    token.includes('backendfailure') ||
    token.includes('backend_failure') ||
    isLaunchUnavailableToken(value)
}

function isUnsafeHomeCategoryUrl(value) {
  const url = String(value == null ? '' : value).trim()
  if (!url) return true
  if (/^https?:\/\//i.test(url)) return false
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return true
  return isLaunchUnavailableToken(url)
}

function isUnsafeHomeCategoryEntry(entry) {
  const item = homeCategoryObject(entry)
  if (!Object.keys(item).length) return false
  if (isUnavailableLaunchEntry(item)) return true
  if (HOME_CATEGORY_FLAG_KEYS.some((key) => hasHomeCategoryKey(item, key) && isHomeCategoryActiveBlock(item[key]))) return true
  if (HOME_CATEGORY_PROOF_KEYS.some((key) => hasHomeCategoryKey(item, key) && (isHomeCategoryFalseProof(item[key]) || isLaunchUnavailableToken(item[key])))) return true
  if (HOME_CATEGORY_ID_KEYS.some((key) => hasHomeCategoryKey(item, key) && isLaunchUnavailableToken(item[key]))) return true
  return HOME_CATEGORY_URL_KEYS.some((key) => hasHomeCategoryKey(item, key) && isUnsafeHomeCategoryUrl(item[key]))
}

function firstHomeCategoryList(source, depth = 0, seen = []) {
  if (Array.isArray(source)) return source
  if (!source || typeof source !== 'object' || depth >= 8 || seen.includes(source)) return null
  seen.push(source)
  for (const key of HOME_CATEGORY_LIST_KEYS) {
    if (Array.isArray(source[key])) return source[key]
  }
  for (const key of HOME_CATEGORY_NESTED_LIST_KEYS) {
    const nested = source[key]
    if (!nested || typeof nested !== 'object') continue
    const list = firstHomeCategoryList(nested, depth + 1, seen)
    if (Array.isArray(list)) return list
  }
  return null
}

function homeCategoryContentWithList(content) {
  const base = homeCategoryObject(content)
  if (HOME_CATEGORY_LIST_KEYS.some((key) => Array.isArray(base[key]))) return base
  const list = firstHomeCategoryList(base)
  return Array.isArray(list) ? { ...base, dataList: list } : base
}

function sanitizeHomeCategoryType(type) {
  const safeType = homeCategoryObject(type)
  if (!Object.keys(safeType).length || isUnsafeHomeCategoryEntry(safeType)) return null
  return {
    ...safeType,
    games: toArray(safeType.games).filter((game) => !isUnsafeHomeCategoryEntry(game))
  }
}

function sanitizeHomeCategoryGroup(group) {
  const safeGroup = homeCategoryObject(group)
  if (!Object.keys(safeGroup).length || isUnsafeHomeCategoryEntry(safeGroup)) return null
  return {
    ...safeGroup,
    types: toArray(safeGroup.types)
      .map(sanitizeHomeCategoryType)
      .filter(Boolean)
  }
}

function normalizeSafeHomeCategoryContent(content) {
  const normalized = normalizeHomeGameContent(homeCategoryContentWithList(content))
  return {
    ...normalized,
    dataList: toArray(normalized.dataList)
      .map(sanitizeHomeCategoryGroup)
      .filter(Boolean)
  }
}
export default {
  name: 'home',
  // components: { ResherSiper, ResherContent, MenuHome },
  // components: { ResherSiper, ResherContent },
  // components: { ResherSiper2, ResherContent },
  components: { ResherSiper2 },

  data() {
    return {
      selectMenIndex: 1,
      MenList: [
        {
          img: require('@/assets/img/home/men_1.png'),
          name: this.$lang.common_txt138
        },
        {
          img: require('@/assets/img/home/men_2.png'),
          name: this.$lang.common_txt139
        }
      ],
      totalSeconds: 1800, // 30分钟 = 1800秒
      timer5: null,
      isCountdownActive: true,
      agree2: false,
      agree: false,
      isRegister: safeGetStorageItem(getLocalStorage(), 'isRegister'),
      showDialog: false,
      isShowPopup2: false,
      // currentValue: 10029898.87, // 初始值
      // numberImages: {
      //   0: require('@/assets/img/common/0.png'),
      //   1: require('@/assets/img/common/1.png'),
      //   2: require('@/assets/img/common/2.png'),
      //   3: require('@/assets/img/common/3.png'),
      //   4: require('@/assets/img/common/4.png'),
      //   5: require('@/assets/img/common/5.png'),
      //   6: require('@/assets/img/common/6.png'),
      //   7: require('@/assets/img/common/7.png'),
      //   8: require('@/assets/img/common/8.png'),
      //   9: require('@/assets/img/common/9.png'),
      //   ',': require('@/assets/img/common/10.png'),
      //   '.': require('@/assets/img/common/11.png')
      // },
      // timer2: null,
      isShowPopup: false,
      showPopup: false,
      itemWidth: 72, // 单个元素的宽度（单位：px）
      activeTab: 0,
      prizeAmount: 11002030,
      typeIndex: null,
      allOpen: false,
      loading: false,
      winDate: [],
      pgDate: {},
      // 自定义中奖轮播：偏移(px)、触摸起点、是否禁用过渡、自动播放定时器
      winnerOffsetX: 0,
      winnerTouchStartX: 0,
      winnerNoTransition: false,
      winnerAutoplayTimer: null,
      winnerItemWidth: 65,
      winnerGap: 10,
      timer: null,
      serachName: '',
      homeGameLoaded: false,
      homeGameError: false,
      homeGameReadError: '',
      homeWinningReadError: '',
      homeWinningLoaded: false,
      filteredDataList: [], // 过滤后的数据
      topHdlist: [
        {
          img: require('@/assets/img/common/top-2-1.png'),
          title: 'Sorteio Diário'
        },
        {
          img: require('@/assets/img/common/top-2-2.png'),
          title: 'Vip'
        },
        {
          img: require('@/assets/img/common/top-2-3.png'),
          title: 'Atividade'
        },
        {
          img: require('@/assets/img/common/top-2-4.png'),
          title: 'Compartilhar'
        }
      ],
      images: [
        require('@/assets/img/activity/banner0.png'),
        require('@/assets/img/activity/banner1.png'),
        require('@/assets/img/activity/banner2.png'),
        require('@/assets/img/activity/banner3.png')
        // require('@/assets/img/activity/banner4.png')
      ],
      socialLinks: [
        { src: require('@/assets/img/otgame/pinduoduo_21.png'), serviceType: 'facebook' },
        { src: require('@/assets/img/otgame/pinduoduo_24.png'), serviceType: 'twitter' },
        { src: require('@/assets/img/otgame/ins.png'), serviceType: 'instagram' },
        { src: require('@/assets/img/otgame/zjm_42.png'), serviceType: 'tiktok' }
      ],
      communityLinks: [
        { src: require('@/assets/img/otgame/group-chat.png'), serviceType: 'telegram' },
        { src: require('@/assets/img/otgame/channel.png'), serviceType: 'telegram' }
      ],
      btImgs: [
        {
          img: require('@/assets/img/common/logo_h.png'),
          name: 'Responsible GameBling'
        }
        // {
        //   img: require('@/assets/img/common/img_anb.png'),
        //   name: 'About'
        // },
        // {
        //   img: require('@/assets/img/common/img_do.png'),
        //   name: 'T&C’s FAQs'
        // }
      ],
      btImgs2: [
        require('@/assets/img/common/18_ss.png'),
        require('@/assets/img/common/tt_icon.png'),
        require('@/assets/img/common/whats-w.png'),
        require('@/assets/img/common/facebook.png'),
        require('@/assets/img/common/img_tt.png')
      ],
      // activeList: [
      //   require('@/assets/img/common/active1.png'),
      //   require('@/assets/img/common/active2.jpg'),
      //   require('@/assets/img/common/active3.jpg'),
      //   require('@/assets/img/common/active3.jpg'),
      //   require('@/assets/img/common/active3.jpg'),
      //   require('@/assets/img/common/active3.jpg')
      // ],
      allItems: [],
      currentPage: 0,
      itemsPerPage: 5,
      timer3: null,
      isOtgame: []
    }
  },
  watch: {
    totalSeconds(newVal) {
      const currentTime = Math.floor(Date.now() / 1000)
      const newEndTime = currentTime + newVal
      safeSetStorageItem(getLocalStorage(), 'countdownEndTime', String(newEndTime))
    }
  },
  computed: {
    formattedMinutes() {
      return Math.floor(this.totalSeconds / 60)
    },
    formattedSeconds() {
      return this.formatNumber(this.totalSeconds % 60)
    },
    // formattedNumber() {
    //   // 格式化数字：句号代表千分位，逗号代表小数
    //   const parts = this.currentValue.toString().split('.')
    //   const integerPart = parts[0]
    //   const decimalPart = parts[1] || ''
    //   // 插入千分位句号
    //   const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    //   // 确保小数点后两位
    //   const formattedDecimal = decimalPart.padEnd(2, '0').slice(0, 2)
    //   // 组合结果
    //   return `${formattedInteger},${formattedDecimal}`.split('')
    // },
    displayedItems() {
      const start = this.currentPage * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.allItems.slice(start, end)
    },
    // 中奖轮播：原始列表、三份拼接用于无限循环、轨道样式
    winnerList() {
      return (this.winDate && this.winDate.dataList) || []
    },
    winnerDisplayList() {
      const list = this.winnerList
      if (!list.length) return []
      return [...list, ...list, ...list]
    },
    homeWinnerEmptyState() {
      return this.homeWinningLoaded && !this.homeWinningReadError && this.winnerDisplayList.length === 0
    },
    winnerTrackStyle() {
      const w = this.winnerItemWidth + this.winnerGap
      const total = this.winnerDisplayList.length * w
      return {
        width: total + 'px',
        transform: `translate3d(${this.winnerOffsetX}px, 0, 0)`
      }
    }
  },
  created() {
    this.GetInvitationID()
    // this.GetIsFbReport()
    this.GetHomeGameList()
    this.GetHomeWinningGameList()
  },
  async mounted() {
    this.GetPlatformList()
    // if (!this.GET_PLATFORM) {
    //   this.$router.replace('/Country')
    //   return
    // }
    this.initCountdown()
    if (this.shouldOpenRegisterAwardPopup()) {
      this.ActivitygetRegisterAward()
    }
    // 检查今日不显示
    const today = new Date().toISOString().split('T')[0]
    // 检查今日不显示
    // if (safeGetStorageItem(sessionStorage, 'neverShowToday') === today) {
    //   this.isShowPopup2 = false
    // } else if (safeGetStorageItem(getLocalStorage(), 'neverShow')) {
    //   // 检查永久不显示
    //   this.isShowPopup2 = false
    // } else {
    //   this.isShowPopup2 = true
    // }

    if (safeGetStorageItem(getSessionStorage(), 'neverShowToday2') === today) {
      this.showDialog = false
    } else if (safeGetStorageItem(getLocalStorage(), 'neverShow2')) {
      // 检查永久不显示
      this.showDialog = false
    } else {
      // this.showDialog = true
    }
    // if (
    //   safeGetStorageItem(getLocalStorage(), 'isRegister') === 'isRegister' &&
    //   this.isShowPopup2 === false
    // ) {
    //   this.showDialog = true
    // this.resetCountdown()
    // }
    // this.startTimer()
    this.startTimer2()
    this.loadSavedValue()
    // if (this.$route.query.id) {
    //   safeSetStorageItem(getLocalStorage(), 'id', this.$route.query.id)
    // }
    // await this.GetIsFbReport()
    // if (this.$route.query?.id && !this.token) {
    // if (this.$route.query?.id) {
    //   safeSetStorageItem(
    //     'fbExpand',
    //     this.$pixel.getUrlFBParams().replace('#/home?', '&')
    //   )
    //   // this.showPopup = true
    // }
    this.$bus.$on('message-sent', (v) => {
      safeScrollIntoView(() => this.$refs.targetElement, {
        behavior: 'smooth', // 平滑滚动
        block: 'start' // 垂直方向对齐方式
      })
      this.activeTab = v
    })
  },
  beforeDestroy() {
    if (this.timer2) {
      clearInterval(this.timer2)
    }
    if (this.timer3) {
      clearInterval(this.timer3)
    }
    this.winnerStopAutoplay()
    this.$bus.$off('message-sent')
  },
  methods: {
    safeTypes(item) {
      return toArray(item && item.types)
    },
    gameList(item) {
      return toArray(item && item.games)
    },
    async openConfiguredSocialLink(serviceType) {
      try {
        const data = await GetCsLink()
        const link = resolveHomeSocialLink(data, serviceType)
        if (link.ok && openExternalUrl(link.url)) return
        this.$toast({
          message: link.message || HOME_SOCIAL_UNAVAILABLE_MESSAGE,
          icon: 'cross'
        })
      } catch (e) {
        this.$toast({
          message: HOME_SOCIAL_UNAVAILABLE_MESSAGE,
          icon: 'cross'
        })
      }
    },
    async GetInvitationID() {
      try {
        const data = await GetInvitationID({
          inviteCode: safeGetStorageItem(getLocalStorage(), 'id')
        })
        const content = responseContent(data)
        if (isOkResponse(data) && content.invitCode) {
          safeSetStorageItem(getLocalStorage(), 'id', content.invitCode)
          setTimeout(() => {
            this.GetIsFbReport()
          }, 200)
        }
      } catch (e) {
        safeRemoveStorageItem(getLocalStorage(), 'id')
      }
    },
    async GetPlatformList() {
      // 单国模式:平台/币种由 singleCountry 锁死,跳过远程平台列表覆盖(防污染 storage);仅多国模式生效。
      if (SINGLE_COUNTRY) return
      try {
        const data = await GetPlatformList()
        if (isReadableOkResponse(data)) {
          const content = responseContent(data)
          const list = toArray(content.list || content.dataList || content.platformList || content.records || content.items)
          const path = this.$route.path // 此时path的值是 "/CIV/home"
          // 按/分割路径，过滤空字符串（避免开头/导致的空元素）
          const pathArr = path.split('/').filter((item) => item)
          // 分割后数组是 ["NG", "home"]，取第一个元素就是NG
          if (pathArr.length > 1) {
            const newArr = list.filter(
              (item) => item.country === pathArr[0]
            )
            if (newArr.length === 0) {
              return
            }
            const platform = safeObject(newArr[0])
            const prevPlatform = safeGetStorageItem(getLocalStorage(), 'platform')
            logoutIfReloginRequiredWithToken(prevPlatform, platform.platform)
            safeSetStorageItem(getLocalStorage(), 'currency', safeString(platform.currency))
            safeSetStorageItem(getLocalStorage(), 'areaCode', safeString(platform.areaCode))
            safeSetStorageItem(getLocalStorage(), 'currencyUnit', safeString(platform.currencyUnit))
            safeSetStorageItem(getLocalStorage(), 'platform', safeString(platform.platform))
            safeSetStorageItem(getLocalStorage(), 'defaultLanguage', safeString(platform.defaultLanguage))
            safeSetStorageItem(getLocalStorage(), 'iconUrl', safeString(platform.iconUrl))
            safeSetStorageItem(getLocalStorage(), 'countryName', safeString(platform.countryName))
            safeSetStorageItem(getLocalStorage(), 'country', safeString(platform.country))
            // setTimeout(() => {
            //   window.location.reload()
            // }, 200)
          }
        }
      } catch (e) {
        // Keep home usable even when platform bootstrap is temporarily unavailable.
      }
    },
    // noticeText(dataArr) {
    //   if (dataArr) {
    //     return dataArr
    //       .map(
    //         (item) =>
    //           `${item.userName} : ${
    //             this.$lang.home_txt
    //           } ${this.$formatNumberWithCommas(item.amount)} ${
    //             this.$lang.BRL
    //           }  `
    //       )
    //       .join('  |  ') // 使用分隔符区分不同通知
    //   }
    // },
    gotoAc(i) {
      if (i === 0) {
        this.$jumpTo('/Crowdfunding')
      } else if (i === 1) {
        this.$jumpTo('/signIn')
      } else if (i === 2) {
        this.$jumpTo('/redPacket')
      } else if (i === 3) {
        this.$jumpTo('/referFriend')
      } else if (i === 4) {
        this.$jumpTo('/cashBack')
      }
    },
    serachGo() {
      this.$jumpTo('/category')
    },
    closeActive() {
      this.showDialog = false
    },
    closeActive2() {
      this.showDialog = true
    },
    shouldOpenRegisterAwardPopup() {
      if (!this.token) return false
      const today = new Date().toISOString().split('T')[0]
      if (safeGetStorageItem(getSessionStorage(), 'neverShowToday') === today) return false
      if (safeGetStorageItem(getLocalStorage(), 'neverShow') === 'true') return false
      return true
    },
    markerToken(value) {
      return String(value == null ? '' : value).trim().toLowerCase()
    },
    isTrueFlag(value) {
      if (value === true || value === 1) return true
      return ['1', 'true', 'yes', 'on'].includes(this.markerToken(value))
    },
    isFalseFlag(value) {
      if (value === false || value === 0) return true
      return ['0', 'false', 'no', 'off'].includes(this.markerToken(value))
    },
    isRegisterAwardOkValue(value) {
      if (value === true) return true
      return ['ok', 'success', 'successful', 'succeeded', 'completed', '0', '00', '0000', '200'].includes(this.markerToken(value))
    },
    isRegisterAwardOkResponse(data, content) {
      if (!data || isNeedLogin(data)) return false
      return [
        data.status,
        data.state,
        data.result,
        data.code,
        data.errorCode,
        data.success,
        content.status,
        content.state,
        content.result,
        content.code,
        content.errorCode,
        content.success
      ].some(value => this.isRegisterAwardOkValue(value))
    },
    isRegisterAwardPopupAvailable(content) {
      const explicitClaimable = this.isTrueFlag(content.claimable) || this.isTrueFlag(content.canReceive)
      const blocked = this.isTrueFlag(content.readOnlyQuery) ||
        this.isTrueFlag(content.readOnly) ||
        this.isTrueFlag(content.readOnlyMode) ||
        this.isTrueFlag(content.read_only_mode) ||
        this.isTrueFlag(content.writeBlocked) ||
        this.isTrueFlag(content.write_blocked) ||
        this.isTrueFlag(content.backendBlocked) ||
        this.isTrueFlag(content.backend_blocked) ||
        this.isTrueFlag(content.rewardBackendBlocked) ||
        this.isTrueFlag(content.dataUnavailable) ||
        this.isTrueFlag(content.data_unavailable) ||
        this.isTrueFlag(content.fallback) ||
        this.isTrueFlag(content.mock) ||
        this.isTrueFlag(content.mockMode) ||
        this.isTrueFlag(content.mock_mode) ||
        this.isFalseFlag(content.rewardWritable)
      return Number(content.receiveStatus) === 1 && explicitClaimable && !blocked
    },
    async ActivitygetRegisterAward() {
      try {
        const data = await ActivitygetRegisterAward()
        const content = responseContent(data)
        this.isShowPopup2 = this.isRegisterAwardOkResponse(data, content) && this.isRegisterAwardPopupAvailable(content)
      } catch (e) {
        this.isShowPopup2 = false
      }
    },
    resetCountdown() {
      // 重置倒计时
      this.stopCountdown()
      this.isCountdownActive = true
      this.totalSeconds = 1800 // 重置为30分钟
      const endTime = Math.floor(Date.now() / 1000) + this.totalSeconds
      safeSetStorageItem(getLocalStorage(), 'countdownEndTime', String(endTime))
      this.startCountdown()
    },
    formatNumber(num) {
      return num.toString().padStart(2, '0')
    },
    startCountdown() {
      this.timer5 = setInterval(() => {
        this.totalSeconds--

        if (this.totalSeconds <= 0) {
          this.stopCountdown()
          this.isCountdownActive = false
          safeRemoveStorageItem(getLocalStorage(), 'countdownEndTime')
        }
      }, 1000)
    },
    stopCountdown() {
      if (this.timer5) {
        clearInterval(this.timer5)
        this.timer5 = null
      }
    },
    initCountdown() {
      const storedEndTime = safeGetStorageItem(getLocalStorage(), 'countdownEndTime')

      if (storedEndTime) {
        const endTime = parseInt(storedEndTime)
        const currentTime = Math.floor(Date.now() / 1000)

        if (currentTime < endTime) {
          this.totalSeconds = endTime - currentTime
          this.startCountdown()
        } else {
          this.isCountdownActive = false
        }
      } else {
        const endTime = Math.floor(Date.now() / 1000) + this.totalSeconds
        safeSetStorageItem(getLocalStorage(), 'countdownEndTime', String(endTime))
        this.startCountdown()
      }
    },
    closeF() {
      if (this.agree) {
        // 今日不显示
        const today = new Date().toISOString().split('T')[0]
        safeSetStorageItem(getSessionStorage(), 'neverShowToday2', today)
      }
      if (this.agree2) {
        // 永久不显示
        safeSetStorageItem(getLocalStorage(), 'neverShow2', 'true')
      }
      this.showDialog = false
    },
    submit2() {
      safeRemoveStorageItem(getLocalStorage(), 'isRegister')
      safeRemoveStorageItem(getSessionStorage(), 'neverShowToday2')
      safeRemoveStorageItem(getLocalStorage(), 'neverShow2')
      this.showDialog = false
      // this.$router.push('/recharge')
      if (this.token) {
        this.isShowPopup2 = false
        this.$jumpTo('/rechargeCont')
      } else {
        this.isShowPopup2 = false
        this.showPopup = true
      }
    },
    async GetIsFbReport() {
      try {
        const data = await GetIsFbReport({
          inviteCode: safeGetStorageItem(getLocalStorage(), 'id')
        })
        const content = responseContent(data)
        const pixelId = safeString(content.fbPixId)
        if (!isOkResponse(data) || !content.isReport || !pixelId) return
        if (content.target === 'ks') {
          const kwaiq = getKwaiq()
          if (
            kwaiq &&
            typeof kwaiq.load === 'function' &&
            typeof kwaiq.instance === 'function'
          ) {
            kwaiq.load(pixelId)
            const tracker = kwaiq.instance(pixelId)
            if (tracker && typeof tracker.track === 'function') {
              tracker.track('contentView')
            }
          }
          return
        }
        const pixel = this.$pixel || null
        if (pixel && typeof pixel.setFbId === 'function') {
          pixel.setFbId(pixelId)
        }
        if (pixel && typeof pixel.callTrack === 'function') {
          pixel.callTrack('track', 'ViewContent')
        }
        if (pixel && typeof pixel.sendEventToAndroid === 'function') {
          const jsonData = JSON.stringify({
            data: [
              {
                event_name: 'ViewContent',
                content_name: 'Open Home Page',
                content_category: 'Electronics',
                content_ids: [],
                content_type: 'product',
                value: 0,
                currency: safeString(safeGetStorageItem(getLocalStorage(), 'currency'), (SINGLE_COUNTRY && SINGLE_COUNTRY.currency) || 'XOF')
              }
            ]
          })
          pixel.sendEventToAndroid(jsonData)
        }
      } catch (e) {
        // Pixel reporting must never block the home page.
      }
    },
    shareContent(i) {
      if (i === 1) {
        if (canUseNativeShare()) {
          const nativeShare = getNativeShare()
          if (!nativeShare) {
            safeToast(this, {
              message: SHARE_UNSUPPORTED_MESSAGE,
              icon: 'cross'
            })
            return
          }
          let shareResult
          try {
            // 分享链接用当前实际服务域名(origin)而非写死的他域,并带上本人邀请码做推荐归因 ——
            // 否则裂变流量会被导去一个可能未上线的域名、且丢失邀请关系。
            const win = browserWindow()
            const origin = (win && win.location && win.location.origin) || 'https://otgame.wiralomi.com'
            const inviteCode = safeString(safeGetStorageItem(getLocalStorage(), 'id'))
            const shareUrl = inviteCode ? `${origin}/?id=${encodeURIComponent(inviteCode)}` : `${origin}/`
            shareResult = nativeShare.share.call(nativeShare.nav, {
              title: 'VUKAVI',
              text: 'VUKAVI',
              url: shareUrl
            })
          } catch (error) {
            const message = shareFailureMessage(error)
            if (message) {
              safeToast(this, {
                message,
                icon: 'cross'
              })
            }
            return
          }
          if (shareResult && typeof shareResult.catch === 'function') {
            shareResult.catch(error => {
              const message = shareFailureMessage(error)
              if (message) {
                safeToast(this, {
                  message,
                  icon: 'cross'
                })
              }
            })
          }
        } else {
          safeToast(this, {
            message: SHARE_UNSUPPORTED_MESSAGE,
            icon: 'cross'
          })
        }
      }
    },
    getImagePath(char) {
      return this.numberImages[char]
    },
    // addRandomValue() {
    //   // 随机增加整数部分 1-100
    //   const integerRandom = Math.floor(Math.random() * 100) + 1
    //   // 随机增加小数部分 0.01-0.99
    //   const decimalRandom = (Math.floor(Math.random() * 100) / 100).toFixed(2)
    //   // 将小数部分转换为数值
    //   const decimalValue = parseFloat(decimalRandom)
    //   // 更新当前值
    //   this.currentValue += integerRandom + decimalValue
    //   // 确保小数点后两位
    //   this.currentValue = parseFloat(this.currentValue.toFixed(2))
    //   // 保存到 safe storage
    //   safeSetStorageItem(getLocalStorage(), 'savedValue', String(this.currentValue))
    // },
    // startTimer() {
    //   this.timer2 = setInterval(() => {
    //     this.addRandomValue()
    //   }, 1000)
    // },
    startTimer2() {
      this.timer3 = setInterval(() => {
        this.currentPage++
        if (this.currentPage * this.itemsPerPage >= this.allItems.length) {
          this.currentPage = 0
        }
      }, 3000) // 每 3 秒切换一次
    },
    loadSavedValue() {
      const savedValue = safeGetStorageItem(getLocalStorage(), 'savedValue')
      if (savedValue) {
        // if (savedValue > 99999999) {
        //   this.currentValue = 10029898.87
        // } else {
        this.currentValue = parseFloat(savedValue)
        // }
      }
    },
    gotoRefer() {
      this.$jumpTo('/referFriend')
    },
    getBacks() {
      safeScrollIntoView(() => this.$refs.targetElement, {
        behavior: 'smooth', // 平滑滚动
        block: 'start' // 垂直方向对齐方式
      })
    },
    tabSelect() {
      this.allOpen = false
      // this.$router.push({
      //   path: '/category',
      //   query: { gameTab: this.activeTab }
      // })
      // scrollIntoView(this.$refs.targetElement, {
      //   behavior: 'smooth', // 平滑滚动
      //   block: 'start' // 垂直方向对齐方式
      // })
    },
    goVendor(vendor) {
      if (!vendor || !vendor.code) {
        if (typeof this.$toast === 'function') {
          this.$toast({
            message: (this.$lang && this.$lang.vendor_entry_unavailable) || HOME_VENDOR_ENTRY_UNAVAILABLE_MESSAGE,
            icon: 'cross'
          })
        }
        return
      }
      this.$jumpTo('/category', { vendorCode: vendor.code })
    },
    // 是否展开全部
    openAll(item, index) {
      this.allOpen = true
      this.typeIndex = index
      this.$jumpTo('/category')
      // scrollIntoView(this.$refs.targetElement, {
      //   behavior: 'smooth', // 平滑滚动
      //   block: 'start' // 垂直方向对齐方式
      // })
    },
    async GetHomeGameList() {
      this.homeGameLoaded = false
      this.homeGameError = false
      try {
        const data = await GetHomeGameList()
        const canReadGameList = typeof isHomeGameReadableResponse === 'function'
          ? isHomeGameReadableResponse(data)
          : isReadableOkResponse(data)
        if (canReadGameList) {
          const responseBody = typeof gameResponseBody === 'function' ? gameResponseBody(data) : responseContent(data)
          const normalized = normalizeSafeHomeCategoryContent(responseBody)
          const safeGroups = getVisibleGameGroups(normalized, this.getCurrency)
          const visibleList = typeof filterDisplayGameGroups === 'function'
            ? filterDisplayGameGroups(safeGroups)
            : safeGroups
          const typesArr = visibleList
            .filter((item) => item.sortType !== 1)
            .map((item) => item.types)
            .reduce((acc, current) => acc.concat(current || []), [])

          const newList = [
            {
              name: 'Lobby',
              icon: require('@/assets/img/common/all_home.png'),
              types: typesArr
            },
            ...visibleList
          ].filter((item, index) => index !== 0 || item.types.length > 0)
          this.pgDate = {
            ...normalized,
            dataList: newList
          }
          this.homeGameReadError = ''
        // this.pgDate.dataList.splice(0, this.pgDate.dataList.length, ...newList) // 替换原数组

        // this.pgDate.dataList.forEach((i) => {
        //   i.types.sort((a, b) => a.order - b.order)
        // })

        // let newArr = this.pgDate.dataList[0].types.filter(
        //   (i) => i.code === '3000602'
        // )
        // this.isOtgame = newArr.flatMap((item) =>
        //   item.games.filter((game) => game.gameName === 'Lucky Ball')
        // )
        // this.pgDate.dataList[0].homeIcon = require('@/assets/img/common/all_home.png')
        // // 使用 Vue.set 确保响应式更新
        // for (let i = 0; i < newDataList.length; i++) {
        //   this.$set(this.pgDate.dataList, i + 1, {
        //     homeIcon: newDataList[i].homeIcon,
        //     icon: newDataList[i].icon,
        //     name: newDataList[i].name,
        //     types: [newDataList[i]]
        //   })
        // }
        // this.pgDate.dataList = this.pgDate.dataList.map((lobby) => ({
        //   ...lobby,
        //   gamesNumber: lobby.types.reduce(
        //     (total, type) => total + type.games.length,
        //     0
        //   ) // 计算所有 games 的总长度
        // }))
          // this.$bus.$emit('tab-list', this.pgDate.dataList)
        } else {
          this.homeGameReadError = this.$lang.home_game_unavailable || 'Game list is temporarily unavailable.'
          this.homeGameError = true
        }
      } catch (e) {
        this.homeGameReadError = this.$lang.home_game_unavailable || 'Game list is temporarily unavailable.'
        this.homeGameError = true
      } finally {
        this.homeGameLoaded = true
      }
    },
    async GetHomeWinningGameList() {
      this.loading = true // 开始加载
      this.homeWinningLoaded = false
      try {
        const data = await GetHomeWinningGameList()
        if (isReadableOkResponse(data)) {
          const content = responseContent(data)
          const dataList = toArray(content.dataList || content.list || content.records || content.items)
          this.winDate = {
            ...content,
            dataList
          }
          this.allItems = dataList
          this.homeWinningReadError = ''
          this.winnerOffsetX = -(
            this.winnerList.length *
            (this.winnerItemWidth + this.winnerGap)
          )
          if (this.winnerList.length) {
            this.$nextTick(() => this.winnerStartAutoplay())
          } else {
            this.winnerStopAutoplay()
          }
        } else {
          this.homeWinningReadError = this.$lang.home_winning_unavailable || 'Winners list is temporarily unavailable.'
        }
      } catch (e) {
        this.homeWinningReadError = this.$lang.home_winning_unavailable || 'Winners list is temporarily unavailable.'
      } finally {
        this.loading = false // 请求结束，关闭加载
        this.homeWinningLoaded = true
      }
    },
    // 中奖轮播：将 offset 限制在中间段，避免露馅
    winnerClampOffset() {
      const list = this.winnerList
      if (!list.length) return
      const w = this.winnerItemWidth + this.winnerGap
      const segment = list.length * w
      if (this.winnerOffsetX >= 0) {
        this.winnerNoTransition = true
        this.winnerOffsetX = -segment
        this.$nextTick(() => {
          this.winnerNoTransition = false
        })
      } else if (this.winnerOffsetX <= -segment * 2) {
        this.winnerNoTransition = true
        this.winnerOffsetX = -segment
        this.$nextTick(() => {
          this.winnerNoTransition = false
        })
      }
    },
    onWinnerTouchStart(e) {
      this.winnerStopAutoplay()
      this.winnerTouchStartX = e.touches[0].clientX
    },
    onWinnerTouchMove(e) {
      const dx = e.touches[0].clientX - this.winnerTouchStartX
      this.winnerTouchStartX = e.touches[0].clientX
      this.winnerOffsetX += dx
    },
    onWinnerTouchEnd() {
      this.winnerClampOffset()
      this.winnerStartAutoplay()
    },
    winnerStartAutoplay() {
      this.winnerStopAutoplay()
      if (!this.winnerList.length) return
      const w = this.winnerItemWidth + this.winnerGap
      this.winnerAutoplayTimer = setInterval(() => {
        this.winnerOffsetX -= w
        this.winnerClampOffset()
      }, 3000)
    },
    winnerStopAutoplay() {
      if (this.winnerAutoplayTimer) {
        clearInterval(this.winnerAutoplayTimer)
        this.winnerAutoplayTimer = null
      }
    },
    goToDetail(i) {
      if (i === 0) {
        this.$jumpTo('/vipSignIn')
      } else if (i === 1) {
        this.$jumpTo('/cashBack')
      } else if (i === 2) {
        this.$jumpTo('/signIn')
      } else if (i === 3) {
        this.$jumpTo('/share')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.otag-gg {
  // background: url('../../assets/img/otgame/gonggao_07.png') no-repeat;
  height: 45px;
  background-size: 100% 100%;
}
.image-bottom—container {
  display: flex; /* 使用 Flex 布局 */
  flex-direction: row; /* 水平排列 */
  justify-content: space-between; /* 可选值：space-between / center / space-around / space-evenly */
  align-items: center; /* 垂直居中 */
  padding-bottom: 15px;
}
.image—logo {
  width: auto;
  height: 30px;
  object-fit: cover;
  border-radius: 0px;
}
.image-bottom—text {
  font-size: var(--vk-fs-xs);
  word-wrap: break-word;
}
.content {
  // padding-top: 60px;
  margin-bottom: 12%;
  // background: @background-color;
  // background: url('../../assets/img/page_bg2.png') no-repeat center center;
  background-size: cover;
  // height: 100vh;
  // overflow-y: scroll;
  /* 隐藏滚动条样式 */
  &::-webkit-scrollbar {
    display: none;
  }
  ::v-deep .van-overlay {
    z-index: 1999 !important;
  }
  .notice-swipe {
    height: 20px;
    line-height: 20px;
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
  }
}
.content-swiper {
  width: 100%;
  text-align: center;
}
// ====== BANNER SWIPER ======
.banner-swiper {
  padding: 0 12px;
  margin-bottom: 10px;

  &__swipe {
    border-radius: 10px;
    overflow: hidden;
  }

  &__img {
    width: 100%;
    display: block;
    border-radius: 10px;
  }

  ::v-deep .van-swipe__indicator--active {
    background: var(--vk-brand); /* banner 指示器·激活=火焰橙 */
    width: 16px;
    border-radius: 4px;
  }

  ::v-deep .van-swipe__indicator {
    background: rgba(255, 255, 255, 0.4);
  }
}
.content-swiper--img {
  border-radius: 10px;
  width: 100%;
  margin-top: 10px;
  padding: 0 15px;
}
.content-serach {
  margin: 10px auto 10px;
  width: 94%;
  scroll-margin-top: 32px; /* 向上偏移 50px */
}
.search-entry-wrap {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: var(--vk-surface-2); /* 搜索入口底 */
  border-radius: 10px;
  cursor: pointer;
  .search-entry-icon {
    flex-shrink: 0;
    margin-right: 8px;
    opacity: 0.9;
  }
  .search-entry-placeholder {
    color: var(--vk-t2);
    font-size: var(--vk-fs-base);
  }
}
.custom-field {
  padding: 5px;
  background: @cont-bg;
  border-radius: 10px;
  border: none;
  ::v-deep .van-field__control {
    /* 修改输入框的字体颜色 */
    color: #ffffff;
  }
}
.van-cell {
  color: #ffffff;
}
::v-deep .van-field__value {
  caret-color: var(--vk-brand); /* 输入框光标=火焰橙 */
}
.custom-button {
  padding: 16px 5px;
  background: var(--vk-grad); /* CTA=火焰橙渐变 */
  color: #ffffff; /* 按钮文字颜色 */
  border: none; /* 去除边框 */
  border-radius: 8px;
  font-size: var(--vk-fs-xs);
}
.content-winner {
  width: 94%;
  margin: 15px auto 0;
}
/* 中奖金额=钱 → 金(覆盖全局 .primary-color 绿) */
.content-winner--t {
  color: var(--vk-gold);
  font-weight: bold;
}
/* 自定义中奖轮播：从左到右、可左右滑动、无限循环 */
.winner-carousel-wrap {
  margin-top: 15px;
  overflow: hidden;
  touch-action: pan-y pinch-zoom;
  height: 145px;
}
.winner-carousel-track {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  transition: transform 0.3s ease-out;
}
.winner-carousel-no-transition {
  transition: none !important;
}
.winner-carousel-item {
  flex-shrink: 0;
  width: 65px;
  margin-right: 10px;
}

.content-winne--swiper {
  .swiper-slide {
    text-align: center;
    font-size: var(--vk-fs-2xs);
  }
  .swiper-slide .swiper-slide--img {
    border-radius: 8px;
    height: 80px;
    width: 120px;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
}
.tab-icon {
  width: 25px; /* 图标宽度 */
  // height: 35px; /* 图标高度 */
  // vertical-align: middle; /* 垂直居中对齐 */
}

.content-tab {
  margin: 0 auto;
  width: 100%;
}
/* 自定义选中状态的 Tab 样式 */
::v-deep .van-tab--active {
  color: #ffffff !important;
  // background: url(../../assets/img/home/tab-bg.png) no-repeat !important;
  // background-size: cover !important;
  // background: linear-gradient(to bottom, #172f4d, #172943, #17233a) !important;
  // border: 1px solid #2283f6 !important;
}

::v-deep .van-tabs__nav--line.van-tabs__nav--complete {
  // background-color: @background-color;
  // background: url(../../assets/img/home/tab-cont.png) no-repeat !important;
  background: transparent !important;
  // background-size: 100% 100%;
  color: #ffffff !important;
  padding-left: 0;
  padding-right: 0;
}
::v-deep .van-sticky--fixed {
  top: 50px;
}
::v-deep .van-tabs__wrap--scrollable {
  // background: #f3f5f9;
  // padding: 0px 15px 0px 0;
  padding: 0 10px;
}
.tab-title-column {
  background: var(--vk-surface-2); /* 分类胶囊·未激活底 */
  padding: 3px 5px;
  border-radius: 6px;
  color: var(--vk-t2); /* 分类胶囊·未激活文字 */
  white-space: nowrap;
  width: 80px;
  overflow: hidden;
}
.tab-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 50px;
}
.vendor-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 10px 0;
}
.vendor-grid__item {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:active {
    opacity: 0.7;
  }
}
.vendor-grid__icon {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: contain;
  background: var(--vk-surface-2); /* 厂商宫格 icon 底 */
}
.vendor-grid__name {
  margin-top: 6px;
  font-size: var(--vk-fs-xs);
  color: var(--vk-t2);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 70px;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
  // background-color: #00000000;
  // min-width: 52px;
  padding: 0 4px !important;
  border-radius: 15px;
  text-align: center;
  // font-weight: bold;
  // background-image: radial-gradient(
  //   circle at 50% 50%,
  //   #7041f3 0%,
  //   rgba(112, 65, 243, 0.25) 50%
  // );
  // border: 1px solid rgba(255, 255, 255, 0.08);
  // flex-flow: column !important;
  // justify-content: space-between !important;
  // height: 100%;
  // margin-left: 5px;
}
::v-deep .van-tabs__line {
  display: none;
}
.content-tab--ct {
  margin: 0 0 5px;
  justify-content: space-between;
}
.content-tab--ctt {
  // background-color: #262e3d;
  border-radius: 10px;
  padding: 6px 9px;
}
.content-tab--ctt2 {
  background: var(--vk-surface-2); /* 原 selecct-game.png 浅蓝药丸→ token 面色(去蓝) */
  border-radius: 999px;
  min-width: 42px;
  text-align: center;
  padding: 5px 0;
  color: @font-color;
}
::v-deep .van-tab {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-bbttom {
  width: 100%;
  // padding-bottom: 10%;
  // padding-top: 12px;
  // margin-top: 3%;
  // background: url('../../assets/img/home/home_bottom_bg.jpg') no-repeat;
  // height: 435px;
  // background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  padding-bottom: 15px;
}

.content-line {
  margin: 15px auto;
  width: 100%;
  height: 1px;
  background: #303243;
  opacity: 0.7;
}
.item-sider {
  width: 65px; /* 单个元素的宽度 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  ::v-deep .van-image__img {
    border-radius: 8px;
  }
}
.item-sider--t {
  position: relative;
  bottom: 0;
  font-size: 9px;
  text-align: center;
}
::v-deep .custm-swiper {
  width: 100%;
  .van-swipe__indicator {
    width: 13px;
    border-radius: 12px;
    color: transparent !important;
  }
  .van-swipe__indicator--active {
    width: 35px;
    color: transparent !important;
  }
}
.content-tab--s {
  ::v-deep .van-loading {
    background: transparent;
  }
}
.notice-bar {
  display: flex;
  align-items: center;
  margin: 10px;
  font-size: var(--vk-fs-base);
  color: #000;
}

.notice-text-wrapper {
  display: flex;
  align-items: center;
  background-color: #edf9f5a8;
  margin-right: 10px;
  border-radius: 6px;
  padding: 6px;
  flex: 1;
  overflow: hidden;
  position: relative;
}

.inner-icon {
  width: 18px;
  height: 14px;
  flex-shrink: 0;
  margin-right: 6px;
}

.scroll-container {
  overflow: hidden;
  white-space: nowrap;
  flex: 1;
  position: relative;
}

.notice-text {
  display: inline-block;
  white-space: nowrap;
  font-weight: 500;
  animation: scroll-text 10s linear infinite;
  animation-play-state: running !important;
}

.notice-text-wrapper:hover .notice-text {
  animation-play-state: paused;
}

@keyframes scroll-text {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.news-icon {
  height: 21px;
  width: auto;
  flex-shrink: 0;
}
.custom-popup2 {
  width: 86%;
  text-align: center;
  background-color: transparent; /* 设置背景色 */
  // z-index: 2004 !important;
  .cont-redim {
    // padding-top: 330px;
    background: url(../../assets/img/common/syhd.png) no-repeat;
    background-size: 100% 100%;
    height: 420px;
    border-radius: 15px;
  }

  ::v-deep .van-checkbox__icon .van-icon {
    border: none;
  }
  ::v-deep .van-checkbox__icon--checked .van-icon {
    background-color: var(--vk-brand) !important;
  }
  .van-overlay {
    z-index: 2001 !important;
  }
}
.van-notice-bar {
  // height: 32px;
  width: 93%;
  border-radius: 10px;
  margin-left: 3%;
  padding: 0 10px;
  background: rgba(255, 255, 255, 0.04);
}
.bot-swiper-b {
  ::v-deep .van-swipe__indicator--active {
    width: 25px !important;
    border-radius: 10px !important;
  }
  ::v-deep .van-swipe__indicator {
    width: 12px;
    border-radius: 10px !important;
  }
  ::v-deep .van-swipe__indicators {
    bottom: 0px;
  }
}
.a-ccc {
  color: #ffffff !important;
  background: var(--vk-brand); /* 分类胶囊·激活=火焰橙 */
}
.home-read-error {
  margin: 8px 12px 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: rgba(255, 193, 7, 0.12);
  color: #ffd36a;
  font-size: var(--vk-fs-xs);
  line-height: 1.4;
}
.home-winner-empty {
  margin: 12px 0 0;
  min-height: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  color: #aeb7cc;
  font-size: var(--vk-fs-xs);
}
/* PC 端样式 */
@media (min-width: 769px) {
  .cont-redim {
    height: 477px !important;
    padding-top: 383px !important;
  }
  .custom-popup2 {
    width: 370px !important;
  }
  ::v-deep .van-sticky--fixed {
    top: 110px !important;
  }
}
</style>
